import SubstrateClass from "./SubstrateClass";

export default interface SubstrateClassStandardSelection {
  kind: "standard";
  substrateClass: SubstrateClass;
  substrateClassType: string | null;
}

export function labelOfSelectionStandard(selection: SubstrateClassStandardSelection): string {
  return selection.substrateClass.name + (selection.substrateClassType ? ` (${selection.substrateClassType})` : "");
}

export function keyOfSelectionStandard(selection: SubstrateClassStandardSelection): string {
  return selection.substrateClass.tmbId + (selection.substrateClassType || "");
}
